<div class="progress-bar-wrapper" *ngIf="progressValue > 0">
    <mat-progress-bar [value]="progressValue" [color]="progressColor">
    </mat-progress-bar>
</div>
